export const EXPORT_PAGE_SIZE = 1000;

/** Upper bound on HTTP pages — avoids a runaway loop if the API ignores offset or returns duplicates. */
const MAX_EXPORT_PAGES = 5000;

export async function fetchAllPaginated({ totalRecords, fetchPage, pageSize = EXPORT_PAGE_SIZE }) {
  const total = Number(totalRecords) || 0;
  if (total <= 0 || typeof fetchPage !== 'function') return [];

  const allRows = [];
  let offset = 0;
  let pages = 0;

  while (offset < total && pages < MAX_EXPORT_PAGES) {
    pages += 1;
    const limit = Math.min(pageSize, total - offset);
    const response = await fetchPage({ offset, limit });
    const pageRows = Array.isArray(response?.data) ? response.data : [];

    if (pageRows.length === 0) break;

    allRows.push(...pageRows);
    const nextOffset = offset + pageRows.length;
    if (nextOffset === offset) break;
    offset = nextOffset;

    if (pageRows.length < limit) break;
  }

  return allRows.slice(0, total);
}
